import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader, Center } from '@mantine/core';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredUserType = 'admin' }) => {
  const { user, userType, loading } = useAuth();
  const [cookieChecked, setCookieChecked] = useState(false);
  const [cookieUser, setCookieUser] = useState(null);

  useEffect(() => {
    const checkCookieAuth = async () => {
      if (requiredUserType === 'member' && !user) {
        try {
          const response = await fetch('https://app-fearless-february.samrruddhi.in/api/member/check-auth', {
            method: 'GET',
            credentials: 'include',
            headers: {
              'Accept': 'application/json',
            },
          });

          if (response.ok) {
            const data = await response.json();
            if (data.authenticated) {
              localStorage.setItem('token', data.token);
              localStorage.setItem('user', JSON.stringify(data.member));
              localStorage.setItem('userType', 'member');
              setCookieUser(data.member);
            }
          }
        } catch (error) {
          console.error('Cookie auth check failed:', error);
        }
      }
      setCookieChecked(true);
    };

    if (!loading) {
      checkCookieAuth();
    }
  }, [user, requiredUserType, loading]);

  if (loading || !cookieChecked) {
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    );
  }

  const currentUser = user || cookieUser;
  const currentUserType = userType || (cookieUser ? 'member' : null);

  if (!currentUser || currentUserType !== requiredUserType) {
    const redirectPath = requiredUserType === 'admin' ? '/admin/login' : '/member/login';
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default ProtectedRoute;